import React, { PropsWithoutRef, useEffect, useState } from 'react';
import DropDownPicker, { DropDownPickerProps, LanguageType } from 'react-native-dropdown-picker';
import { getDefaultLanguage } from '../services/translate';
import { ActivityIndicator, ColorValue, View } from 'react-native';
import defaultColors from '../services/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { WindowInformation } from '../services/window-information';
import { useStyles } from 'react-native-unistyles';
import MyAppText from './MyAppText';

export type ValueType = string | number | boolean;

export default function MyDropDownPicker(props: PropsWithoutRef<DropDownPickerProps<ValueType>> & {
    borderColor?: ColorValue;
    placeholderColor?: ColorValue;
    height?: number;
    isLoading?: boolean;
}) {
    const windowInfo = WindowInformation();
    const { theme } = useStyles();
    const [dropDownLanguage, setDropDownLanguage] = useState<LanguageType>('PT');

    let height = 40;
    if (props.height) {
        height = props.height;
    }

    useEffect(() => {
        (async () => {
            const language = await getDefaultLanguage();
            setDropDownLanguage(language.split('-')[0].toUpperCase() as LanguageType);
        })();
    }, []);

    return <DropDownPicker
        {...props}
        loading={props.isLoading}
        language={dropDownLanguage}
        badgeDotColors={defaultColors}
        searchWithRegionalAccents
        badgeTextStyle={{
            color: '#222222'
        }}
        ListEmptyComponent={({
            listMessageContainer, listMessageTextStyle, message
        }) => {
            return <View style={[{ flex: 1, padding: 10, alignItems: 'center' }, listMessageContainer]}>
                {props.loading ? (
                    <ActivityIndicator color={theme.colors.loadingColor} />
                ) : (
                    <MyAppText style={listMessageTextStyle}>
                        {message}
                    </MyAppText>
                )}
            </View>;
        }}
        searchTextInputProps={{
            autoFocus: !windowInfo.isMobile,
        }}
        listItemContainerStyle={{
            flex: 1,
            padding: 5,
            minHeight: 32
        }}
        style={
            [props.style, {
                height: height,
                minHeight: height,
                borderWidth: 1,
                borderRadius: 4,
                flex: 1,
                borderColor: props.borderColor || theme.colors.neutral['300'],
                backgroundColor: props.disabled ? theme.colors.field.disabledBackground : theme.colors.field.background
            }]}
        placeholderStyle={{
            color: props.placeholderColor || theme.colors.placeholder
        }}
        textStyle={{
            fontSize: 16,
            color: theme.colors.textColor,
            fontFamily: 'Open Sans',
        }}
        dropDownContainerStyle={{
            borderColor: props.borderColor || theme.colors.neutral['300'],
            borderRadius: 4,
            backgroundColor: props.disabled ? theme.colors.field.disabledBackground : theme.colors.field.background
        }}
        searchTextInputStyle={{
            borderColor: props.borderColor || theme.colors.neutral['300'],
            borderRadius: 4,
            color: theme.colors.textColor,
        }}
        ArrowDownIconComponent={() => <FontAwesomeIcon icon={faChevronDown} color={theme.colors.textColor} />}
        ArrowUpIconComponent={() => <FontAwesomeIcon icon={faChevronUp} color={theme.colors.textColor} />}
        TickIconComponent={() => <FontAwesomeIcon icon={faCheck} color={theme.colors.textColor} />}
        searchContainerStyle={{
            borderBottomColor: props.borderColor || theme.colors.neutral['300']
        }} />;
}
